import { Component, forwardRef, Injector } from '@angular/core';
import { ComponentUtility } from '@app/class/ComponentUtility';
import { RadioButtonBaseComponent } from '../radio-button-base/radio-button-base.component';
import "./radio-button-small-cards.component.scss";

export interface IRadioButtonSmallCard {
    label: string;
    value: any;
    disabled?: boolean;
}

@Component({
    selector: 'v-radio-button-small-cards',
    template: require('./radio-button-small-cards.component.html'),
    providers: [
        { provide: RadioButtonBaseComponent, useExisting: forwardRef(() => RadioButtonSmallCardsComponent) },
        ComponentUtility.createValueAccessorProvider(RadioButtonSmallCardsComponent),
        ComponentUtility.createValidatorProvider(RadioButtonSmallCardsComponent)
    ]
})
export class RadioButtonSmallCardsComponent extends RadioButtonBaseComponent {

    constructor(
        protected readonly injector: Injector
    ) {
        super(injector);
    }
}
